import { Link } from 'react-router-dom';
import { ArrowUpRight } from '@phosphor-icons/react';
import { Reveal } from '../../lib/motion';

/**
 * "For hoteliers" hand-off — a claim-free invitation. It describes only the real
 * process (submit → our team reviews → approved hotels go live) and avoids any
 * unconfirmed pricing/fee/performance promises. Premium editorial, dark band.
 */
const STEPS = [
  { n: '01', title: 'Share your hotel', body: 'Tell us about your property in a few minutes. No account to set up.' },
  { n: '02', title: 'We take a look', body: 'Our team reviews every submission by hand to keep the collection curated.' },
  { n: '03', title: 'Go live', body: 'Approved hotels appear on BestAcco for travellers to discover and book.' },
];

export function HotelierPitch() {
  return (
    <section aria-labelledby="hotelier-h2" className="grain relative overflow-hidden bg-ink text-cream">
      <div className="px-6 py-20 sm:px-10 lg:px-16 lg:py-28 2xl:px-24">
        <div className="grid gap-12 lg:grid-cols-[1.1fr_0.9fr] lg:gap-20">
          {/* Invitation */}
          <Reveal>
            <h2
              id="hotelier-h2"
              className="max-w-2xl font-serif text-[2.6rem] leading-[0.98] tracking-tight sm:text-6xl"
            >
              Run an independent hotel?{' '}
              <span className="italic text-clay-light">Tell us about it.</span>
            </h2>
            <p className="mt-6 max-w-lg text-lg leading-relaxed text-cream/80">
              BestAcco features a curated collection of independent hotels across
              the US. If you would like yours considered, share a few details and
              our team will take a look.
            </p>
            <div className="mt-9">
              <Link
                to="/list-your-property"
                className="group inline-flex items-center gap-2 rounded-full bg-clay px-7 py-4 text-base font-semibold text-white transition hover:bg-clay-dark focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cream focus-visible:ring-offset-2 focus-visible:ring-offset-ink"
              >
                List your hotel
                <ArrowUpRight className="h-5 w-5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" aria-hidden="true" />
              </Link>
            </div>
          </Reveal>

          {/* Process (factual, no claims) */}
          <Reveal delay={120}>
            <ol className="space-y-7">
              {STEPS.map((s) => (
                <li key={s.n} className="flex gap-5 border-t border-cream/15 pt-6">
                  <span className="font-serif text-3xl leading-none text-clay-light">{s.n}</span>
                  <div>
                    <h3 className="font-serif text-xl text-cream">{s.title}</h3>
                    <p className="mt-1 text-[15px] leading-relaxed text-cream/70">{s.body}</p>
                  </div>
                </li>
              ))}
            </ol>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
